/* eslint-disable react/display-name */
import { useCallback } from 'react';
import { Dropdown } from '@/components/Dropdown';
import type { ButtonRenderProps } from '@/components/Dropdown';
import type { Props as DropdownProps } from '../Dropdown/Dropdown';
import type { ButtonProps } from '@simplywallst/ui-core';
import { Button } from '@simplywallst/ui-core';
import ChevronDownSmallSolid from '@simplywallst/ui-core/icons/ChevronDownSmallSolid';

type Props = {
  btnProps?: Pick<ButtonProps, 'display'>;
} & DropdownProps;

export const MinimalDropdown = ({ label, btnProps, ...props }: Props) => {
  const dropdownButton = useCallback(
    (label) =>
      ({ onBlur, onFocus, onClick, innerRef, name }: ButtonRenderProps) => {
        return (
          <Button
            styleType="gentle"
            alignIcon="right"
            onBlur={onBlur}
            onFocus={onFocus}
            onClick={onClick}
            ref={innerRef}
            data-cy-id={name}
            display={btnProps?.display}
          >
            <span data-cy-id={`${name}-text`}>{label}</span>
            <ChevronDownSmallSolid />
          </Button>
        );
      },
    [btnProps?.display]
  );
  return <Dropdown {...props} isMinimal buttonRender={dropdownButton(label)} />;
};
